import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex);

const store = new Vuex.Store({
  //定义全局状态
  state: {
    token:'',
    currentUser: null,
    isLogin: false,
    carCount: 0,
    userInfo:{}
  },
  // getters,
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js